/* Ludidoo – keeps the cart drawer above the Pandectes cookie bar (sets --ld-consent-h). */
(function () {
  if (window.__ldConsentPad) return; window.__ldConsentPad = true;
  var root = document.documentElement, t, watched = null, ro = null, mo2 = null;
  function banner() { return document.querySelector('.pd-cookie-banner-window, .cc-window.cc-banner'); }
  function update() {
    var el = banner(), h = 0;
    if (el) {
      var cs = getComputedStyle(el), r = el.getBoundingClientRect();
      var shown = cs.display !== 'none' && cs.visibility !== 'hidden' && parseFloat(cs.opacity) > 0.05 &&
        !el.classList.contains('cc-invisible') && r.height > 0 && r.top < innerHeight && r.bottom >= innerHeight - 4;
      if (shown) h = Math.max(0, Math.round(innerHeight - r.top));
      if (el !== watched) watch(el);
    }
    root.style.setProperty('--ld-consent-h', h + 'px');
  }
  function soon() { clearTimeout(t); t = setTimeout(update, 60); setTimeout(update, 700); }
  function watch(el) {
    watched = el;
    if (mo2) mo2.disconnect();
    mo2 = new MutationObserver(soon); mo2.observe(el, { attributes: true, attributeFilter: ['class', 'style', 'hidden'] });
    if (window.ResizeObserver) { if (ro) ro.disconnect(); ro = new ResizeObserver(soon); ro.observe(el); }
    el.addEventListener('transitionend', soon);
  }
  function init() {
    update();
    new MutationObserver(soon).observe(document.body, { childList: true });
    addEventListener('resize', soon);
    document.addEventListener('click', soon, true);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
